import React, { useState } from "react";
import { Modal, Button } from "antd";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const oneYearFromNow = () => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    return d;
};

const BatchExpirationModal = ({ visible, onClose, userIds, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [neverExpire, setNeverExpire] = useState(false);
    const [expirationDatetime, setExpirationDatetime] = useState(oneYearFromNow());

    const handleSubmit = async () => {
        if (!userIds?.length) {
            toast.error(<p dir="rtl" className="font-custom">کاربری انتخاب نشده است</p>, { autoClose: 3000 });
            return;
        }

        try {
            setLoading(true);
            await axios.post(
                `${config.apiBaseUrl}/api/Users/BatchUpdateExpiration`,
                {
                    userIds,
                    expirationDatetime: neverExpire ? null : expirationDatetime,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        HeaderKey: config.HeaderKey,
                    },
                    withCredentials: true,
                }
            );
            toast.success(
                <p dir="rtl" className="font-custom">تاریخ انقضا با موفقیت به‌روزرسانی شد</p>,
                { autoClose: 3000 }
            );
            setNeverExpire(false);
            setExpirationDatetime(oneYearFromNow());
            onSuccess?.();
            onClose();
        } catch (error) {
            const errMsg = error.response?.data?.message || "خطا در به‌روزرسانی تاریخ انقضا";
            toast.error(<p dir="rtl" className="font-custom">{errMsg}</p>, { autoClose: 3000 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={() => {
                setNeverExpire(false);
                setExpirationDatetime(oneYearFromNow());
                onClose();
            }}
            footer={null}
            centered
            destroyOnClose
            title={<span className="font-custom">به‌روزرسانی تاریخ انقضا</span>}
        >
            <div className="font-custom text-right space-y-4 py-2">
                <p className="text-gray-600">
                    {userIds?.length || 0} کاربر انتخاب شده
                </p>
                <div>
                    <label className="text-sm text-gray-600 block mb-2">:تاریخ انقضا</label>
                    <div className="flex flex-wrap items-center gap-3 justify-end">
                        <DatePicker
                            calendar={persian}
                            locale={persian_fa}
                            value={neverExpire ? null : expirationDatetime}
                            onChange={(date) =>
                                setExpirationDatetime(date?.toDate?.() || oneYearFromNow())
                            }
                            calendarPosition="bottom-right"
                            disabled={neverExpire}
                        />
                        <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={neverExpire}
                                onChange={(e) => setNeverExpire(e.target.checked)}
                            />
                            بدون انقضا
                        </label>
                    </div>
                </div>
                <Button
                    type="primary"
                    block
                    disabled={loading}
                    onClick={handleSubmit}
                    className="font-custom"
                >
                    {loading ? <FaSpinner className="animate-spin inline" /> : "اعمال"}
                </Button>
            </div>
        </Modal>
    );
};

export default BatchExpirationModal;
